import { LinkButton } from '@cian/ui-kit/button';
import * as React from 'react';

export interface IPhoneButtonProps {
  phone?: string | null;
  text?: string;
  onClick?(): void;
  beforeIcon?: React.ReactElement;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ text = 'Позвонить', phone, onClick, beforeIcon }) => {
  if (!phone) {
    return null;
  }

  return (
    <LinkButton fullWidth href={`tel:+${phone}`} onClick={onClick} beforeIcon={beforeIcon}>
      {text}
    </LinkButton>
  );
};
